<div class="welcome-modal">

  <!-- Header -->
  <div class="welcome-header">
    <div class="welcome-logo">
      <span class="logo-text">H<span class="logo-sep">|</span>HOTELGEX</span>
    </div>
    <button type="button" class="btn-close-custom" (click)="close()">×</button>
  </div>

  <!-- Progress bar -->
  <div class="progress-bar-wrapper">
    <div class="progress-bar-track">
      <div class="progress-bar-fill" [style.width.%]="progress"></div>
    </div>
    <div class="step-dots">
      <button *ngFor="let s of steps; let i = index"
              class="step-dot"
              [class.active]="i === currentStep"
              [class.done]="i < currentStep"
              (click)="goTo(i)">
        <span *ngIf="i < currentStep">✓</span>
        <span *ngIf="i >= currentStep">{{ i + 1 }}</span>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div class="welcome-body">
    <div class="step-icon">{{ current.icon }}</div>
    <h2 class="step-title">{{ current.title }}</h2>
    <p class="step-description">{{ current.description }}</p>

    <ul class="step-items">
      <li *ngFor="let item of current.items">
        <span class="item-check">✓</span>
        <span>{{ item }}</span>
      </li>
    </ul>

    <a *ngIf="isLast" class="manual-link" routerLink="/manuel-utilisation" (click)="close()">
      <span class="manual-link-icon">📖</span>
      Pour plus d'informations, consultez le <strong>Manuel d'utilisation</strong>
    </a>

    <div class="step-counter">{{ currentStep + 1 }} / {{ steps.length }}</div>
  </div>

  <!-- Footer -->
  <div class="welcome-footer">
    <button *ngIf="!isFirst" class="btn-prev" (click)="prev()">
      ← Précédent
    </button>
    <div *ngIf="isFirst" class="spacer"></div>


    <button *ngIf="!isLast" class="btn-next" (click)="next()">
      Suivant →
    </button>
    <button *ngIf="isLast" class="btn-start" (click)="close()">
      Commencer
    </button>
  </div>

</div>
